import { Button, Grid } from "@mui/material";
import { Select } from "antd";
import { SelectBtnIcon, TopToBottomIcon } from "assets/svgs";
import { AutoCompleteFilter, CommonButton, DateYearFilter, Navbar } from "components";
import { class_grade } from "constants/pageConstants";
import { useApi } from "hooks/useApi/useApiHooks";
import useQueryHook from "hooks/useQueryHook";
import { IAcademicYear } from "pages/settings/academic-years/types";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { OrderHeaderStyled, SecondRowShow } from "styles/global.style";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExplicitIcon from '@mui/icons-material/Explicit';

export interface ITableNavbarProps {
  data: IAcademicYear[];
  handlePrint?: () => void;
  exportToExcel?: () => void;
}

export const TableNavbar: FC<ITableNavbarProps> = ({ data, handlePrint, exportToExcel }) => {
  const { AddQueryParams, QueryParams } = useQueryHook();
  const { t } = useTranslation();
  const [isTrue, setIsTrue] = useState<boolean>(false);

  const { data: statusDate } = useApi(`payment-status/all`);

  return (
    <>
      <Navbar
        title={t("general.monthly_payment")}
        actionButtons={
          <div className="flex gap-2">
            <Select
              className="h-11"
              options={data.map((item: IAcademicYear) => ({
                label: `${new Date(item.startsAt).toLocaleDateString(
                  "ru"
                )}-${new Date(item.endsAt).toLocaleDateString("ru")}`,
                value: item._id,
              }))}
              onChange={(value) => {
                const foundAcademicYear = data?.find((item) => item._id === value);
                AddQueryParams({ selectedYear: foundAcademicYear?._id });
              }}
              defaultValue={
                data.find(
                  (item: IAcademicYear) =>
                    new Date(item.startsAt) <= new Date() &&
                    new Date(item.endsAt) >= new Date()
                )?._id || QueryParams?.selectedYear
              }
            />
            <CommonButton
              title={t("general.export")!}
              className="complete"
              startIcon={<ExplicitIcon style={{ fontSize: "25px" }} />}
              onClick={() => {
                exportToExcel?.()
              }}
            />
            <CommonButton
              title={t("general.export")!}
              className="color-red"
              startIcon={<PictureAsPdfIcon style={{ fontSize: "25px" }} />}
              onClick={() => {
                handlePrint?.()
              }}
            />
            <OrderHeaderStyled>
              <Button className="filter_btn" onClick={() => setIsTrue(!isTrue)}>
                <div>
                  <SelectBtnIcon />
                  <span>{t("LABELS.FILTER.FILTER_TITLE")}</span>
                </div>
                <div className={isTrue ? "icon active" : "icon"}>
                  <TopToBottomIcon />
                </div>
              </Button>
            </OrderHeaderStyled>

          </div>
        }
      />
      <SecondRowShow in={isTrue}>
        <Grid
          container
          spacing={1}
          display={"flex"}
          justifyContent={"flex-end"}
          paddingRight={"8px"}
          sx={{
            backgroundColor: "white",
            paddingBottom: "10px",
            paddingInline: "10px",
          }}
        >
          <Grid item md={3} xs={6}>
            <AutoCompleteFilter
              placeholder={t("LABELS.STUDENT")!}
              filterName="studentId"
              optionsUrl="students/pagin"
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <AutoCompleteFilter
              placeholder={t("LABELS.CLASS")!}
              filterName="classId"
              optionsUrl="/class/pagin"
              dataProp="data.data"
              getOptionLabel={(option) => `${option?.grade}-${option?.letter} ${option?.name}`}
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <DateYearFilter
              clearable
              filterName="month"
              type="month"
            />
          </Grid>
          <Grid item md={3} xs={6}>
            <AutoCompleteFilter
              placeholder={t("LABELS.STATE")!}
              filterName="statusId"
              options={statusDate?.data.map((value: any) => ({
                ...value,
                _id: value._id,
                name: t(value.text),
              }))}
            />
          </Grid>
        </Grid>
      </SecondRowShow>
    </>
  );
};
